export enum ExceptionLevel {
  information, warning, error, success
}

export default ExceptionLevel;